import React, { Component } from 'react'
import { checkTranslation, chooseFontColor, conditionalWidth, imageAddress, translate } from '../../utils/useful'
// import IntractionActionsList from '../IntractionActionsList'
// import Collapsible from 'react-collapsible'
// import FixedView from '../FixedView'
// import StagesManager from '../StagesManager'


import BookingFrame from './BookingFrame'
import StaticFrame from './StaticFrame'
import DynamicFrame from './DynamicFrame'
import EmailFrame from './EmailFrame'
import SettingFrame from './SettingFrame'
import InqueriesFrame from './InqueriesFrame'

// import DataMenu from './DataMenu'
// import ToolsMenu from './ToolsMenu'

// import EmailFile from './EmailFile'

import HeaderInformation from './HeaderInformation'
// import CollectionToolbar from './CollectionToolbar'
// import EmailToolbar from './EmailToolbar'
import DeskFrame from './DeskFrame'
import DashboardsSettingsFrame from './DashboardsSettingsFrame'
import PortalsSelectApplet from '../useful/PortalsSelectApplet'
import NotebookFrame from './NotebookFrame'


export default class Header extends Component {
    state = {
        bg: 'linear-gradient(90deg, #347f00, #42c200)',
        collapses: {},

    }
    componentDidMount() {

    }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }



    render() {
        let title = this.props?.config?.title
        if (title == '') {
            title = null
        }

        let type = this.props.applet?.type

        if (!type && Array.isArray(this.props.applet?.features)) {
            type = this.props.applet.features[0]
        }

        let primaryColor = this.props.colors?.primaryColor ?? '#505050'
        let secondaryColor = this.props.colors?.secondaryColor ?? '#696969'

        let background = `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`


        return (
            <div className='w-100'>
                <div className={' w-100 flexcc flex-column ' + (' window-content-radius-top')} style={{ zIndex: 1, background: background }}>

                    <HeaderInformation config={this.props?.config} hub={this.props.hub} setHeader={this.props.setHeader} changeNav={this.props.changeNav} backActionMobile={this.props.backActionMobile} headertype={this.props.headertype} username={this.props.username} changePage={this.props.changePage} addToCart={this.props.addToCart} types={this.props.types} cart={this.props.cart} functionsHandler={this.props.functionsHandler} showSettings={this.props.showSettings} colors={this.props.colors} showHome={this.props.showHome} title={title} applet={this.props.applet} page={this.props.page} width={this.props.width} backbtn={this.props.backbtn} backStage={this.props.backStage} goToHub={this.props.goToHub} changeWindow={this.props.changeWindow} changeWindowLink={this.props.changeWindowLink} data={this.props.data} variables={this.props.variables} sections={this.props.sections} modules={this.props.modules} frames={this.props.frames} addNewWindow={this.props.addNewWindow} />

                    {this.props.config?.showToolbar == true && (
                        <div className='flexcb w-100  sc-2 ' style={{ background: this.props.colors?.iconInvert ? 'rgba(40, 40, 40, 0.04)' : 'rgba(255, 255, 255, 0.04)', overflowX: 'auto', height: '46px' }}>
                            <div className='flexc w-100'>
                                

                                {(this.props.config.showFrames == 'static' || this.props.config.showFrames == true) && (
                                    <StaticFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} frames={this.props.frames} variables={this.props.variables} updateFrames={this.props.updateFrames} />
                                )}

                                {this.props.config.showFrames == 'desk' && (
                                    <DeskFrame permissions={this.props.permissions} language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} frames={this.props.config.frames} />
                                )}

                                {this.props.config.showFrames == 'booking' && (
                                    <BookingFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} applet={this.props.applet} user={this.props.user} tabIndex={this.props.tabIndex} functionsHandler={this.props.functionsHandler} colors={this.props.colors} setData={this.props.setData} />
                                )}

                                {this.props.config.showFrames == 'inquery' && (
                                    <InqueriesFrame frame={this.props.fram} language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} list={this.props.list} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} addNewForm={this.props.addNewForm} />
                                )}
                                {this.props.config.showFrames == 'applet' && (
                                    <DynamicFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} />
                                )}
                                {this.props.config.showFrames == 'settings' && (
                                    <SettingFrame width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} modules={this.props.modules} settings={this.props.settings} settingsSections={this.props.settingsSections} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} />
                                )}

                                {this.props.config.showFrames == 'email' && (
                                    <EmailFrame accounts={this.props.accounts} userPerspective={this.props.userPerspective} width={this.props.width} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} />
                                )}
                                {this.props.config.showFrames == 'dashboardsSettings' && (
                                    <DashboardsSettingsFrame language={this.props.language} width={this.props.width} userPerspective={this.props.userPerspective} sections={this.props.sections} list={this.props.list} modules={this.props.modules} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} colors={this.props.colors} addNewForm={this.props.addNewForm} />
                                )}
                                {/* <button className='mrd-2 flexcc dark-blur-hover px-2 br-5 py-1' ref={el => this.view = el} onClick={() => { this.viewView.showView() }}>
                                        <p className='white font-size-13'>{translate('Views')}</p>
                                        <div className='br-20 mld-1 flexcc' style={{ color: this.props.color ?? '#000', backgroundColor: 'rgba(255, 255, 255, 0.1)', height: 20, minWidth: 20 }}>
                                            <p className='text-smaller text-semibold white'>3</p>
                                        </div>
                                    </button>
                                    <DataMenu color={this.props.color} language={this.props.language} width={this.props.width} />
                                    <ToolsMenu language={this.props.language} width={this.props.width} /> */}

                                {this.props.config?.toolbar && (
                                    this.props.config.toolbar()
                                )}

                                {/* {this.props.toolbarView == 'applet' &&
                                    <CollectionToolbar functionsHandler={this.props.functionsHandler} color={this.props.color} language={this.props.language} width={this.props.width} />
                                }

                                {this.props.toolbarView == 'email' &&
                                    <EmailToolbar functionsHandler={this.props.functionsHandler} showCheckBox={this.props.showCheckBox} checkBox={this.props.checkBox} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} color={this.props.color} language={this.props.language} width={this.props.width} />
                                } */}

                            </div>

                            {/* {this.props.toolbarView == 'settings' &&
                                <div className='flexc'>
                                    <SettingFrame width={this.props.width} sections={this.props.sections} modules={this.props.modules} settings={this.props.settings} settingsSections={this.props.settingsSections} changePage={this.props.changePage} />
                                    <DataMenu language={this.props.language} width={this.props.width} />
                                    <ToolsMenu language={this.props.language} width={this.props.width} />
                                </div>
                            } */}



                        </div>
                    )}
                </div>

                {/* <FixedView width={this.props.width} zIndex={10} ref={el => this.viewView = el} nodeRef={this.view} xOffset={this.props.language == 'fa' ? 175 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'view'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className='mb-2'>
                                    <IntractionActionsList language={this.props.language} onClick={this.changePageSubMenu} data={{ title: "{{lang}}header.Views List", icon: "/assets/icons/note/view/mode.svg" }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}header.Add View", check: true }} />
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView> */}
            </div>

        )
    }
}
